import React, { FC, useEffect, useState } from 'react';

import {
  FormControl as ChakraFormControl,
  Input as ChakraInput,
  Text as ChakraText,
  forwardRef,
  useMultiStyleConfig,
} from '@chakra-ui/react';

import { ComponentReceivedProps } from '@types';

import { defaultProps } from './protocol';
import { InputProps, InputTriggers } from './index';

export const component: FC<ComponentReceivedProps<InputProps, InputTriggers>> = forwardRef(
  ({ props = defaultProps, triggers }, ref) => {
    const { label, size, value, ...rest } = props;
    const { onBlur } = triggers;

    const [state, setState] = useState(value);

    const baseInputStyles = useMultiStyleConfig('PTBaseInput', { size });

    useEffect(() => {
      setState(value);
    }, [value]);

    return (
      <ChakraFormControl>
        {label && <ChakraText sx={baseInputStyles['base-input-label'] || {}}>{label}</ChakraText>}
        <ChakraInput
          {...rest}
          sx={baseInputStyles['base-input-control'] || {}}
          ref={ref}
          value={state}
          onBlur={({ target }) => onBlur && onBlur(target.value)}
          onChange={({ target }) => setState(target.value)}
        />
      </ChakraFormControl>
    );
  },
);
